module.exports = __webpack_public_path__ + "img/image5_en.ee83b589.png";